/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenericDashboardQueryVariables = Types.Exact<{
  integrationId: Types.IntegrationId;
}>;


export type GenericDashboardQuery = { organisationIntegration: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationIntegrationResult', organisationIntegration?: { __typename: 'OrganisationIntegration', id: string, settings: any, integration: { __typename: 'Integration', id: string, integrationId: Types.IntegrationId, name: string }, health?: { __typename: 'IntegrationHealth', health: string, details?: any | null, updatedAt?: string | null } | null, events: Array<{ __typename: 'IntegrationEvent', type: string, title: string, detail?: string | null, metadata?: any | null, createdAt: string } | { __typename: 'IntegrationEventGroup', type: string, count: number, timeRangeFrom: string, timeRangeTo: string }> } | null } };


export const GenericDashboardDocument = gql`
    query GenericDashboard($integrationId: IntegrationId!) {
  organisationIntegration(integrationId: $integrationId) {
    ... on OrganisationIntegrationResult {
      organisationIntegration {
        id
        integration {
          id
          integrationId
          name
        }
        settings
        health {
          health
          details
          updatedAt
        }
        events(limit: 50) {
          ... on IntegrationEvent {
            type
            title
            detail
            metadata
            createdAt
          }
          ... on IntegrationEventGroup {
            type
            count
            timeRangeFrom
            timeRangeTo
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGenericDashboardQuery__
 *
 * To run a query within a React component, call `useGenericDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericDashboardQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGenericDashboardQuery(baseOptions: Apollo.QueryHookOptions<GenericDashboardQuery, GenericDashboardQueryVariables> & ({ variables: GenericDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericDashboardQuery, GenericDashboardQueryVariables>(GenericDashboardDocument, options);
      }
export function useGenericDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericDashboardQuery, GenericDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericDashboardQuery, GenericDashboardQueryVariables>(GenericDashboardDocument, options);
        }
export function useGenericDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenericDashboardQuery, GenericDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenericDashboardQuery, GenericDashboardQueryVariables>(GenericDashboardDocument, options);
        }
export type GenericDashboardQueryHookResult = ReturnType<typeof useGenericDashboardQuery>;
export type GenericDashboardLazyQueryHookResult = ReturnType<typeof useGenericDashboardLazyQuery>;
export type GenericDashboardSuspenseQueryHookResult = ReturnType<typeof useGenericDashboardSuspenseQuery>;
export type GenericDashboardQueryResult = Apollo.QueryResult<GenericDashboardQuery, GenericDashboardQueryVariables>;